"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Select = _interopRequireDefault(require("../Select/Select"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class TabNavigation extends _react.PureComponent {
  constructor(props) {
    super(props);
    this._selectItems = _react.Children.map(props.children, (tab, i) => {
      if (tab) {
        return {
          label: tab.props.label,
          value: i.toString()
        };
      }
    });
  }
  _onSelectChange = ({
    value
  }) => {
    this.props.onTabClick(parseInt(value, 10));
  };
  render() {
    const {
      className,
      children,
      selectedIndex,
      onTabClick
    } = this.props;
    const classes = (0, _classnames.default)('TabNavigation', className);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes,
      role: "tablist"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "TabNavigation-links"
    }, _react.Children.map(children, (tab, i) => {
      if (tab) {
        return /*#__PURE__*/(0, _react.cloneElement)(tab, {
          active: selectedIndex === i,
          index: i,
          onTabClick
        });
      }
    })), /*#__PURE__*/_react.default.createElement(_Select.default, {
      key: new Date(),
      className: "TabNavigation-select",
      defaultValue: selectedIndex.toString(),
      items: this._selectItems,
      onChange: this._onSelectChange
    }));
  }
}
exports.default = TabNavigation;